import { render, staticRenderFns } from "./MarketplaceEditProduct.vue?vue&type=template&id=be8958fc&"
import script from "./MarketplaceEditProduct.vue?vue&type=script&lang=js&"
export * from "./MarketplaceEditProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports